import { getDate, format } from 'date-fns';

import ruLocale from 'date-fns/locale/ru';

type ISODateTime = string;

const getRuDayWithMonth = (day: Date | number) => {
    const pattern = 'd MMMM';

    return format(day, pattern, { locale: ruLocale });
};

export function getPeriodLabel(from: ISODateTime | Date, to: ISODateTime | Date) {
    const fromDate = new Date(from);
    const toDate = new Date(to);

    const isSameMonth = fromDate.getMonth() === toDate.getMonth();

    const fromDay = getDate(fromDate);

    if (isSameMonth) {
        return `${fromDay}–${getRuDayWithMonth(toDate)}`;
    }

    return `${getRuDayWithMonth(fromDate)} – ${getRuDayWithMonth(toDate)}`; //${fromDay} ${} - ${toDay} ${}
}
